/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useEffect, useState, useCallback, useRef,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import moment from 'moment';
import {
  Paper, Avatar, Container, Button, Drawer, Table, TableBody, TableCell, TableFooter, TablePagination, TableRow, Typography, Chip,
} from '@mui/material';
import FilterList from '@mui/icons-material/FilterList';
import * as actions from '../../store/actions';
import Spinner from '../../components/Spinner/index';
import { i18n } from '../../translate/i18n';
import EnhancedTableHead from '../../UI/MaterialTableOverrides/EnhancedTableHead';
import TablePaginationActionsWrapped from '../../UI/MaterialTableOverrides/TablePaginationActions';
import TableTitle from '../../UI/MaterialTableOverrides/TableTitle';
import statusLabel from '../../utils/statusLabel';
import { formatLanguageFromLocalStorage } from '../../utils/formatLanguageFromLocalStorage';

import ModalFilter from './ModalFilter/index';

export default function TableEmpresas(props) {
  const dispatch = useDispatch();
  const textInput = useRef(null);

  const [firstLoad, setFirstLoad] = useState(true);
  const [page, setPage] = useState(1);
  const [alreadySearched, setAlreadySearched] = useState(false);
  const [limit, setLimit] = useState(5);
  const [searchText, setSearchText] = useState('');
  const [orderBy, setOrderBy] = useState('deadline');
  const [order, setOrder] = useState('asc');
  const [exportLoading, setExportLoading] = useState(false);

  const selectedSites = useSelector(state => state.sites.selectedSitesPlaces);


  // Modal Filter
  const filteredUsers = useSelector(state => state.actions.filteredUsers);
  const filteredEquipments = useSelector(state => state.actions.filteredEquipments);
  const filteredPlaces = useSelector(state => state.actions.filteredPlaces);
  const filteredAreas = useSelector(state => state.actions.filteredAreas);
  const filteredStatus = useSelector(state => state.actions.filteredStatus);
  const filteredCompanies = useSelector(state => state.actions.filteredCompanies);
  const filteredStartDate = useSelector(state => state.actions.startDate);
  const filteredEndDate = useSelector(state => state.actions.endDate);

  const localStorageLang = localStorage.getItem("i18nextLng");
  const emailLanguage = formatLanguageFromLocalStorage(localStorageLang);

  const fetchActionsExport = useCallback(() => dispatch(actions.fetchActionsExport(searchText, order, orderBy, selectedSites, filteredPlaces, filteredUsers, filteredStatus, filteredAreas, filteredCompanies, filteredStartDate, filteredEndDate, filteredEquipments, emailLanguage)), [searchText, order, orderBy, filteredPlaces, selectedSites, filteredUsers, filteredStatus, filteredEquipments, filteredStartDate, filteredEndDate, emailLanguage, filteredCompanies])

  const fetchActionsService = useCallback(
    () => dispatch(actions.fetchActions(page, limit, searchText, order, orderBy, selectedSites, filteredPlaces, filteredUsers, filteredStatus, filteredAreas, filteredCompanies, filteredStartDate, filteredEndDate, filteredEquipments)),
    [page, limit, searchText, order, orderBy, selectedSites, filteredPlaces, filteredUsers, filteredStatus, filteredAreas, filteredEquipments, filteredStartDate, filteredEndDate, filteredCompanies],
  );

  const actionsService = useSelector(state => state.actions.actions);
  const actionsFilter = useSelector(state => state.actions.actionsFilter);
  const loading = useSelector(state => state.actions.loading);
  const [isFilterOpen, setIsFilterOpen] = useState(false);


  const headRows = [
    {
      id: '_id', numeric: false, disablePadding: false, label: i18n.t('headRowsTableActions.id'),
    },
    {
      id: 'accountable.name', numeric: false, disablePadding: false, label: i18n.t('headRowsTableActions.sponsor'),
    },
    {
      id: 'createdAt', numeric: false, disablePadding: false, label: i18n.t('headRowsTableActions.createdAt'),
    },
    {
      id: 'deadline', numeric: false, disablePadding: false, label: i18n.t('headRowsTableActions.deadline'),
    },
    {
      id: 'service.equipment.equipmentModel.name', numeric: false, disablePadding: false, label: i18n.t('headRowsTableActions.equipment'),
    },
    {
      id: 'questionText', numeric: false, disablePadding: false, label: i18n.t('headRowsTableActions.action'),
    },
    {
      id: 'service.place.name', numeric: false, disablePadding: false, label: i18n.t('headRowsTableActions.place'),
    },
    {
      id: 'status', numeric: false, disablePadding: false, label: i18n.t('headRowsTableActions.status'),
    },
  ];

  useEffect(() => {
    if (!isEmpty(actionsFilter)) {
      setPage(actionsFilter.page);
      setLimit(actionsFilter.limit);
      setSearchText(actionsFilter.searchText);
      setOrderBy(actionsFilter.orderBy);
      setOrder(actionsFilter.order);
    }
    setFirstLoad(false);
    dispatch(actions.setOpenDrawer(true))

  }, []);

  useEffect(() => {
    if (!firstLoad) {
      fetchActionsService();
      setAlreadySearched(true);
    }
  }, [firstLoad, page, limit, order, orderBy]);

  useEffect(() => {
    if (!firstLoad) {
      setPage(1);
      fetchActionsService();
      setAlreadySearched(true);
    }
  }, [filteredUsers, filteredPlaces, selectedSites, filteredEquipments, filteredStatus, filteredAreas, filteredStartDate, filteredEndDate, filteredCompanies]);

  useEffect(() => {
    if (searchText !== '' || alreadySearched) {
      const timer = setTimeout(() => {
        if (searchText === textInput.current.value) {
          fetchActionsService();
        }
      }, 500);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [searchText, textInput]);

  const handleChangePage = (e, page) => {
    setPage(page + 1);
  };

  const handleChangeRowsPerPage = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  const handleRequestSort = (event, property) => {
    const isDesc = orderBy === property && order === 'desc';
    setOrder(isDesc ? 'asc' : 'desc');
    setOrderBy(property);
  };

  const selectRow = (e, id) => {
    props.history.push(`form-action/${id}`);
  };

  const styles = {
    table: {
      position: 'relative',
      marginBottom: 50,
    },
    tableRow: {
      cursor: 'pointer',
    },
    opacityContainer: {
      opacity: loading ? '0.3' : '1',
    },
    spinner: {
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      top: '-5px',
      opacity: '1',
      zIndex: 2,
    },
    noResults: {
      height: '100px',
    },
    deleteTextConfirm: {
      marginLeft: '-30px',
      fontWeight: 'bold',
    },
    editWidth: {
      width: '90%',
    },
    avatarContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    thumbUp: {
      color: '#349c34',
    },
    thumbDown: {
      color: '#d04545',
    },
    avatar: {
      width: '2.75rem',
      height: '2.75rem',
    },
    avatarSmallText: {
      fontSize: '0.75rem',
      width: '2.75rem',
      height: '2.75rem',
    },
    chip: {
      margin: 5,
      color: 'white',
      // border: '1px solid grey'
    },
    cell: {
      fontSize: '0.775rem',
      padding: '0.25rem',
    },
    cellPhotoContainer: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: '0.5rem',
    },
    buttonFilterContainer: {
      display: 'flex',
      flexDirection: 'row',
      padding: '0px 20px 10px 20px',
    },
    buttonFilterIcon: {
      marginLeft: 5,
    },
    buttonFilter: {
      zIndex: 200,
      backgroundColor: 'green',
      height: '2.2rem',
      width: '6.5rem',
      padding: '1rem',
      color: '#fff',
    },
    clearFilter: {
      cursor: 'pointer',
      textDecoration: 'underline',
      zIndex: 200,
      padding: '0.75rem 0.5rem',
      color: '#000',
    },
    filterContainer: {
      position: 'relative',
      width: '100%',
    },
    filterChipContainer: {
      paddingLeft: 20,
      display: 'flex',
      flexWrap: 'wrap',
    },
    filterChip: {
      cursor: 'pointer',
      margin: 5,
    },
  };

  const deleteFilteredSite = (site) => {
    dispatch(actions.deleteFilteredSite(site));
  };

  const deleteFilteredUser = (user) => {
    dispatch(actions.filterActionUsersRemove(user));
  };

  const deleteFilteredEquipment = (equipment) => {
    dispatch(actions.filterActionEquipmentsRemove(equipment));
  };

  const deleteFilteredPlaces = (place) => {
    dispatch(actions.filterActionPlacesRemove(place))
  }

  const deleteFilteredArea = (area) => {
    dispatch(actions.filterActionAreasRemove(area));
  };

  const deleteFilteredStatus = (status) => {
    dispatch(actions.filterActionStatusRemove(status));
  };

  const deleteFilteredCompany = (companieId) => {
    dispatch(actions.actionsfilterCompaniesRemove(companieId));
  }
  const deleteFilteredStartDate = () => {
    dispatch(actions.filterActionStartDateRemove());
  };

  const deleteFilteredEndDate = () => {
    dispatch(actions.filterActionEndDateRemove());
  };


  const clearFilterButton = () => {
    if ((filteredUsers && filteredUsers.length > 0)
      || (filteredEquipments && filteredEquipments.length > 0)
      || (filteredPlaces && filteredPlaces.length > 0)
      || (filteredAreas && filteredAreas.length > 0)
      || (filteredStatus && filteredStatus.length > 0)
      || (filteredCompanies && filteredCompanies.length > 0)
      || (filteredStartDate)
      || (filteredEndDate)) return <Typography onClick={handleClickClearFilters} style={styles.clearFilter}>{i18n.t('typographyTablesActions.clearFilter')}</Typography>;
  };

  const renderSitesChips = () => (selectedSites && selectedSites.map(site => (<Chip
    key={site._id}
    label={site.name}
    onDelete={() => deleteFilteredSite(site)}
    style={styles.filterChip} />)));
  const renderUsersChips = () => (filteredUsers && filteredUsers.map(user => (<Chip
    key={user.value}
    label={user.label}
    onDelete={() => deleteFilteredUser(user)}
    style={styles.filterChip} />)));
  const renderEquipmentsChips = () => (filteredEquipments && filteredEquipments.map(equipment => (<Chip
    key={equipment.value}
    label={equipment.label}
    onDelete={() => deleteFilteredEquipment(equipment)}
    style={styles.filterChip} />)));
  const renderPlacesChips = () => (filteredPlaces && filteredPlaces.map((place) => (<Chip
    key={place.value}
    label={place.label}
    onDelete={() => deleteFilteredPlaces(place)}
    style={styles.filterChip} />)))
  const renderAreasChips = () => (filteredAreas && filteredAreas.map(area => (<Chip
    key={area.value}
    label={area.label}
    onDelete={() => deleteFilteredArea(area)}
    style={styles.filterChip} />)));

  const renderCompaniesChips = () => (filteredCompanies && filteredCompanies.map(company => (<Chip
    key={company.value}
    label={company.label}
    onDelete={() => deleteFilteredCompany(company.value)}
    style={styles.filterChip} />)));
  const renderStatusChips = () => (filteredStatus && filteredStatus.map(status => (<Chip
    key={status.value}
    label={status.label}
    onDelete={() => deleteFilteredStatus(status)}
    style={styles.filterChip} />)));
  const renderStartDateChip = () => (filteredStartDate && <Chip
    label={`${i18n.t('keyboardDatePickerActionModalFilter.from')}: ${moment(filteredStartDate).format('DD/MM/YYYY')}`}
    onDelete={() => deleteFilteredStartDate()}
    style={styles.filterChip} />);
  const renderEndDateChip = () => (filteredEndDate && <Chip
    label={`${i18n.t('keyboardDatePickerActionModalFilter.to')}: ${moment(filteredEndDate).format('DD/MM/YYYY')}`}
    onDelete={() => deleteFilteredEndDate()}
    style={styles.filterChip} />);

  const handleClickClearFilters = useCallback(() => dispatch(actions.filterActionClear()));

  const exportExcel = () => {
    setExportLoading(true);
    fetchActionsExport().then(response => {
      if (response) {
        window.open(response.url, "_blank")
      }
      setExportLoading(false);
    })
  }

  return <>
    <Drawer
      variant="temporary"
      anchor="right"
      onClose={() => setIsFilterOpen(false)}
      open={isFilterOpen}
    >
      <ModalFilter
        closeModal={() => setIsFilterOpen(false)}
      />
    </Drawer>
    <Container maxWidth="xl">
      <Paper>
        <div style={styles.filterContainer}>
          <TableTitle
            title={i18n.t('tableTitleTableActions.title')}
            placeholder={i18n.t('tableTitleTableActions.placeholder')}
            inputRef={textInput}
            value={searchText}
            onChange={(event) => {
              setPage(1);
              setSearchText(event.target.value);
            }}
            clickExport={exportExcel}
            downloading={exportLoading}
            exportButtonDisabled={loading}
            filter={false}
          />
        </div>
        <div style={styles.filterChipContainer}>
          <Button
            variant="contained"
            onClick={() => setIsFilterOpen(true)}
            style={styles.buttonFilter}>
            {i18n.t('buttonTableActions.text')}
              {' '}
            <FilterList style={styles.buttonFilterIcon} />
          </Button>
          {renderSitesChips()}
          {renderUsersChips()}
          {renderEquipmentsChips()}
          {renderPlacesChips()}
          {renderAreasChips()}
          {renderCompaniesChips()}
          {renderStatusChips()}
          {renderStartDateChip()}
          {renderEndDateChip()}
          {clearFilterButton()}
        </div>
        <Table style={styles.table}>
          <tbody>
            <tr>
              <td>
                {loading
                  && (
                    <div style={styles.spinner}>
                      <Spinner />
                    </div>
                  )}
                {actionsService.rows.length === 0
                  && (
                    <div style={styles.noResults}>
                      {!loading && <Typography style={styles.spinner}>{i18n.t('typographyTablesActions.noResults')}</Typography>}
                    </div>
                  )}
              </td>
            </tr>
          </tbody>
          <EnhancedTableHead
            style={styles.opacityContainer}
            headRows={headRows}
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
          />
          <TableBody style={styles.opacityContainer}>
            {actionsService.rows.map((col, index) => (
              <TableRow
                style={styles.tableRow}
                key={col._id}
                hover
                onClick={event => selectRow(event, col._id)}
              >
                <TableCell style={{
                  ...styles.cell,
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                  paddingLeft: '1rem',
                  width: '3rem'
                }}>{(col._id)?.slice(-6)}</TableCell>

                <TableCell style={styles.cell}>
                  {col.accountables.length > 0
                    ? (
                      col.accountables.map(({ name, _id }) => <Chip key={_id} sx={{ margin: '3px', color: 'black' }} label={name} />)
                    )
                    : <div style={{ paddingLeft: 10 }}>{i18n.t('divTableActions.noAccountable')}</div>
                  }
                </TableCell>
                <TableCell style={styles.cell}>{moment(col.createdAt).format('DD/MM/YYYY')}</TableCell>
                <TableCell style={styles.cell}>{moment(col.deadline).format('DD/MM/YYYY')}</TableCell>
                <TableCell style={styles.cell}>
                  <div>{col.equipment?.equipmentModel?.name}</div>
                  <div style={{ color: 'grey' }}>{col.equipment.serialNumber}</div>
                </TableCell>
                <TableCell style={styles.cell}>{col.actionText}</TableCell>
                <TableCell style={styles.cell}>{col.service.place.name}</TableCell>
                <TableCell style={styles.cell}>
                  <Chip
                    label={statusLabel(col.status, col.deadline).title}
                    style={{ backgroundColor: statusLabel(col.status, col.deadline).color, ...styles.chip }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter style={styles.opacityContainer}>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                labelRowsPerPage={i18n.t('tableTitleTableMaintenances.rowsPerPage')}
                count={actionsService.count}
                rowsPerPage={parseInt(limit)}
                page={page - 1}
                SelectProps={{
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActionsWrapped}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </Paper>
    </Container>
  </>;
}
